import React from 'react';
import Button from 'react-bootstrap/Button';

function ActionButtonLink(props) {
    return <Button type="button" className="action-button-link" variant="link" {...props} />;
}

export default ActionButtonLink;
